import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8155778"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu_item_box" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { style: {"padding":"5px 20px"} }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "count" }
const _hoisted_6 = {
  key: 1,
  class: "seat"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "flex"
}
const _hoisted_10 = { class: "count" }
const _hoisted_11 = {
  key: 1,
  class: "seat"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "menu_name" }
const _hoisted_15 = { class: "flex center top" }
const _hoisted_16 = { class: "text_number" }

import { ref, onMounted, watch } from 'vue';
import { MoreOutlined, MenuFoldOutlined } from '@ant-design/icons-vue';
import { Popover, Modal, message } from 'ant-design-vue';
import http from '@/api/conentCenter/communal';
import CDelModal from '@/components/CDelModal.vue';
import { useRoute } from 'vue-router';
interface menuItem {
  id: number;
  name: string;
  visible: boolean;
  count: number;
  default: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CLeftMenu',
  props: {
    dataSource: null
  },
  emits: ['sortInfo'],
  setup(__props: any, { emit }) {

const props = __props as { dataSource: any };

/**
 * 分类类型 1.文章；2.图片；3.直播；4.文档
 */
const aPopover = Popover;
const aModal = Modal;
const putAway = ref<boolean>(false);

const route = useRoute();
const gatewayId = route.params.gatewayId;

const groupMenu = ref<menuItem[]>([]);
const menuType = ref([
  {},
  {
    icon: 'articleSort',
    name: '文章分类',
  },
  {
    icon: 'imagesSort',
    name: '图片分类',
  },
  {
    icon: 'liveSort',
    name: '直播分类',
  },
  {
    icon: 'documentSort',
    name: '文档分类',
  },
]);

const moreClick = (item: any) => {
  groupMenu.value.forEach((i) => {
    i.id == item.id ? (item.visible = true) : (item.visible = false);
  });
};
const visible = ref<boolean>(false);
const deletes = ref<boolean>(false);
const editId = ref();
const delId = ref();
const editName = ref('');
const changeEdit = (item: any, type: number) => {
  type == 1 ? (editId.value = item.id) : (delId.value = item.id);
  editName.value = item.name;
  type == 1 ? (visible.value = true) : (deletes.value = true);
};
// 重命名
const editSort = () => {
  let params = {
    id: editId.value,
    name: editName.value,
    portal_id: gatewayId,
  };
  http
    .edit_sort(params)
    .then((res) => {
      message.success(res.data.message);
      visible.value = false;
      getSortList(0);
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
const closeDel = () => {
  deletes.value = false;
};
// 删除分类
const delSort = () => {
  let params = {
    id: delId.value,
    type: props.dataSource.menuType,
    portal_id: gatewayId,
  };
  http
    .del_portal_sort({ params })
    .then((res) => {
      message.success(res.data.message);
      deletes.value = false;
      getSortList(0);
    })
    .catch((res) => {
      message.error(res.data.message);
      deletes.value = false;
    });
};
// 获取分类列表
const getSortList = async (status: number) => {
  let params = {
    type: props.dataSource.menuType,
    portal_id: gatewayId,
  };
  await http.get_sort_list({ params }).then((res) => {
    groupMenu.value = res.data.data;
    status == 0 ? emitSortInfo(res.data.data[0]) : '';
    groupMenu.value.forEach((item) => {
      item['visible'] = false;
    });
  });
};
const emitSortInfo = (item: any) => {
  editId.value = item.id;
  emit('sortInfo', item);
};

watch(
  () => props.dataSource.createSort,
  () => {
    setTimeout(() => {
      props.dataSource.createSort == props.dataSource.menuType ? getSortList(1) : '';
    }, 300);
  }
);
watch(
  () => props.dataSource.moveSort,
  () => {
    setTimeout(() => {
      props.dataSource.moveSort == props.dataSource.menuType ? getSortList(1) : '';
    }, 300);
  }
);

onMounted(() => {
  getSortList(0);
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: "left_menu",
    style: _normalizeStyle({ width: putAway.value ? '80px' : '198px' })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["menu_title flex", { center: putAway.value }])
    }, [
      _createVNode(_component_svg_icon, {
        class: "content_live_classify",
        "icon-class": menuType.value[props.dataSource.menuType].icon
      }, null, 8, ["icon-class"]),
      _withDirectives(_createElementVNode("span", null, _toDisplayString(menuType.value[props.dataSource.menuType].name), 513), [
        [_vShow, !putAway.value]
      ])
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupMenu.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["menu_item flex between", { active: editId.value == item.id }]),
          key: index,
          onClick: ($event: any) => (emitSortInfo(item))
        }, [
          _withDirectives(_createElementVNode("p", { class: "menu_name ellipsis" }, _toDisplayString(item.name), 513), [
            [_vShow, !putAway.value]
          ]),
          (putAway.value)
            ? (_openBlock(), _createBlock(_unref(aPopover), {
                key: 0,
                placement: "right"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(item.name), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(item.count) + ")", 1),
                    _createVNode(_unref(aPopover), {
                      visible: item.visible,
                      "onUpdate:visible": ($event: any) => ((item.visible) = $event),
                      trigger: "click",
                      placement: "rightTop"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("p", {
                          style: {"padding":"5px 30px","border-bottom":"1px solid #f7f8fa","cursor":"pointer"},
                          onClick: ($event: any) => (changeEdit(item, 1))
                        }, " 重命名 ", 8, _hoisted_7),
                        _createElementVNode("p", {
                          style: {"padding":"5px 30px","border-bottom":"1px solid #f7f8fa","cursor":"pointer"},
                          onClick: ($event: any) => (changeEdit(item, 2))
                        }, " 删除 ", 8, _hoisted_8)
                      ]),
                      default: _withCtx(() => [
                        (item.default != 1)
                          ? (_openBlock(), _createBlock(_unref(MoreOutlined), {
                              key: 0,
                              class: "out_lined",
                              onClick: _withModifiers(($event: any) => (moreClick(item)), ["stop"])
                            }, null, 8, ["onClick"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_6))
                      ]),
                      _: 2
                    }, 1032, ["visible", "onUpdate:visible"])
                  ])
                ]),
                _: 2
              }, 1024))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(item.count) + ")", 1),
                _createVNode(_unref(aPopover), {
                  visible: item.visible,
                  "onUpdate:visible": ($event: any) => ((item.visible) = $event),
                  trigger: "click",
                  placement: "rightTop"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("p", {
                      style: {"padding":"5px 30px","border-bottom":"1px solid #f7f8fa","cursor":"pointer"},
                      onClick: ($event: any) => (changeEdit(item, 1))
                    }, " 重命名 ", 8, _hoisted_12),
                    _createElementVNode("p", {
                      style: {"padding":"5px 30px","border-bottom":"1px solid #f7f8fa","cursor":"pointer"},
                      onClick: ($event: any) => (changeEdit(item, 2))
                    }, " 删除 ", 8, _hoisted_13)
                  ]),
                  default: _withCtx(() => [
                    (item.default != 1)
                      ? (_openBlock(), _createBlock(_unref(MoreOutlined), {
                          key: 0,
                          class: "out_lined",
                          onClick: _withModifiers(($event: any) => (moreClick(item)), ["stop"])
                        }, null, 8, ["onClick"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11))
                  ]),
                  _: 2
                }, 1032, ["visible", "onUpdate:visible"])
              ]))
        ], 10, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["menu_outline flex", { center: putAway.value }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (putAway.value = !putAway.value))
    }, [
      _createVNode(_unref(MenuFoldOutlined), { class: "out_line" }),
      _createTextVNode(),
      _withDirectives(_createElementVNode("span", _hoisted_14, "收起分类", 512), [
        [_vShow, !putAway.value]
      ])
    ], 2),
    _createVNode(_unref(aModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      centered: "",
      title: "重命名",
      onOk: editSort
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createTextVNode(" 分类名称： "),
          _createVNode(_component_a_input, {
            class: "input_width",
            value: editName.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editName).value = $event)),
            placeholder: "请输入分类名称",
            maxlength: 20,
            size: "small"
          }, {
            suffix: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, _toDisplayString(editName.value.length) + "/20", 1)
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(CDelModal, {
      visible: deletes.value,
      centered: "",
      ok: delSort,
      close: closeDel
    }, {
      title: _withCtx(() => [
        _createTextVNode("此操作将删除该分类，是否继续？")
      ]),
      _: 1
    }, 8, ["visible"])
  ], 4))
}
}

})